module.exports = __webpack_public_path__ + "static/img/guijidian_active.197e527f.png";